/**
 * Invoicing products catalog — `/api/v2/invoicing/products/*`.
 * Prefills invoice line items; admin can create/edit/deactivate.
 * NOTE: updates use PATCH (matching the BE routes).
 */
import instance, { ADMIN_PREFIX } from 'services/api';
import {
  InvoicingProduct,
  ProductInput,
  UpdateProductInput
} from 'types/api/invoicing';

const BASE = `${ADMIN_PREFIX}/invoicing/products`;

/** `GET /invoicing/products?active=true` — catalog list (plain array). */
export const fetchInvoicingProducts = async (
  activeOnly = false
): Promise<InvoicingProduct[]> => {
  const res = await instance.get<InvoicingProduct[]>(BASE, {
    params: activeOnly ? { active: 'true' } : undefined
  });

  return res.data ?? [];
};

/** `POST /invoicing/products` — create a catalog product. */
export const createInvoicingProduct = (input: ProductInput) =>
  instance.post<InvoicingProduct>(BASE, input);

/** `PATCH /invoicing/products/:publicId` — update (any subset). */
export const updateInvoicingProduct = (
  publicId: string,
  input: UpdateProductInput
) => instance.patch<InvoicingProduct>(`${BASE}/${publicId}`, input);

/** `POST /invoicing/products/:publicId/deactivate` — soft-disable. */
export const deactivateInvoicingProduct = (publicId: string) =>
  instance.post<InvoicingProduct>(`${BASE}/${publicId}/deactivate`);
